// Copyright ID Business Solutions Ltd. 2023

class Auth {
  static getToken(): string | null {
    return JSON.parse(window.sessionStorage.getItem('access_token')!) || null;
  }
}

export { Auth };
